/** @jsxImportSource @emotion/react */

import { ICellRendererParams } from "ag-grid-community";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem } from "@inscopix/ideas-eui";
import { ResultsEditorRowDatum } from "components/ToolEditor/ToolEditor.types";

export type ResultControlsRendererProps =
  ICellRendererParams<ResultsEditorRowDatum>;

export const ResultControlsRenderer = ({
  data,
}: ResultControlsRendererProps) => {
  const deleteResultColumn = useToolEditorContext((s) => s.deleteResultColumn);

  const updateResultOrder = useToolEditorContext((s) => s.updateResultOrder);

  if (data === undefined) {
    return null;
  }
  return (
    <EuiFlexGroup gutterSize="none" css={{ marginLeft: -7 }}>
      <EuiFlexItem grow={false}>
        <EuiButtonIcon
          key={`${data.key}-up`}
          iconSize="s"
          aria-label={`Move result ${data.name} up`}
          iconType="arrowUp"
          onClick={() => updateResultOrder(data.key, "UP")}
        />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiButtonIcon
          key={`${data.key}-down`}
          iconSize="s"
          aria-label={`Move result ${data.name} down`}
          iconType="arrowDown"
          onClick={() => updateResultOrder(data.key, "DOWN")}
        />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <EuiButtonIcon
          iconType="trash"
          color="danger"
          onClick={() => deleteResultColumn(data.key)}
        />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
